import { AllPersonnelThemeModeConfig } from './types';

const dark: AllPersonnelThemeModeConfig = {
  allPersonnel: {
    normalButtonBGColor: '#505251',
    normalButtonBorderColor: '2px solid #267DAC',
    modalContainerBGColor: '#DADBDC',
    modalHeaderContainerBGColor: '#505251',
    modalHeaderContainerFontColor: 'white',
  },
};

export default dark;
